import OfferService from '@/services/OfferService'

export default {
  actions: {
    async fetchOffersCollection (ctx) {
      const offersCollection = await OfferService.methods.getOffers()
      ctx.commit('updateOffersCollection', offersCollection.GetOffersResponse.OfferItems.OfferItem)
    },
    async fetchOfferCode (ctx, transactionRef) {
      const offer = await OfferService.methods.getOfferCode(transactionRef)
      // const offer = {
      //   GetOfferCodeResponse: {
      //     ErrorCode: { _text: '1' },
      //     ErrorDescription: { _text: 'Success' },
      //     Code: { _text: '56ghji1z' },
      //     ExpirationDate: { _text: '18-Sep-2020' },
      //     FirstTransactionOnly: { _text: 'False' },
      //     Issue: { _text: '01' },
      //     Nomination: { _text: '8.0000' }
      //   }
      // }
      ctx.commit('updateOfferCode', offer.GetOfferCodeResponse)
    },
    async fetchOfferCodeForSignupUser (ctx) {
      const offerCollection = await OfferService.methods.getOffers()
      if (Array.isArray(offerCollection.GetOffersResponse.OfferItems.OfferItem)) {
        let offercode = offerCollection.GetOffersResponse.OfferItems.OfferItem.find(s => !!s.IsInviteCode._text && !!s.IsReferalCode._text && s.FirstTransactiononly._text && s.TransactionCount._text === '0')
        if (offercode) {
          // Hard code : Changed to Promo code IssueNumber -> Issue
          try {
            offercode.Issue = offercode.IssueNumber
            delete offercode.IssueNumber
          } catch (error) {}
          ctx.commit('updateOfferCode', offercode)
        }
      }
    }
  },
  mutations: {
    updateOffersCollection (state, offersCollection) {
      if (Array.isArray(offersCollection)) {
        state.offersCollection = offersCollection.map(offer => {
          (Object.values(offer).map((e, key) => {
            const objectKey = Object.keys(offer)[key].charAt(0).toLowerCase() + Object.keys(offer)[key].slice(1)
            offer[objectKey] = e._text
          }))
          return offer
        })
      } else if (!!offersCollection && Object.keys(offersCollection).length > 0) {
        (Object.values(offersCollection).map((e, key) => {
          const objectKey = Object.keys(offersCollection)[key].charAt(0).toLowerCase() + Object.keys(offersCollection)[key].slice(1)
          offersCollection[objectKey] = e._text
        }))
        state.offersCollection = [offersCollection]
      }
    },
    updateOfferCode (state, offerCode) {
      if (!!offerCode && Object.keys(offerCode).length > 0) {
        (Object.values(offerCode).map((e, key) => {
          const objectKey = Object.keys(offerCode)[key].charAt(0).toLowerCase() + Object.keys(offerCode)[key].slice(1)
          offerCode[objectKey] = e._text
        }))
      }
      state.offer = offerCode
    }
  },
  getters: {
    getOffersCollection (state) {
      return state.offersCollection
    },
    getOfferCode (state) {
      return state.offer
    }
  },
  state: {
    offerCollection: [],
    offer: {}
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/offer.js